import { Button, DatePicker, Form, Input, Modal, Select } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { getCompanyOfficeMaster, loadSingleStaff } from "../../../redux/rtk/features/user/userSlice";
import { addWorkPlaceHistory } from "../../workPlaceHistory/workPlaceHistoryApis";



const WorkPlaceAddSinglePopup = ({ list, setLoading }) => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [form] = Form.useForm();
	const [startDate, setWorkPlaceStartDate] = useState(null);
	const [endDate, setWorkPlaceEndDate] = useState(null);
	const [loader, setLoader] = useState(false);
	const [workPlaceId, setWorkPlaceId] = useState("");
	const workPlace = useSelector((state) => state.workPlace?.list);
	const officeName = useSelector((state) => state.users?.officeName);
	const [companyNames, setCompanyNames] = useState([]);

	const { Option } = Select;

	const user_id = useParams("id");
	const dispatch = useDispatch();

	const onFinish = async (values) => {
		setLoader(true);
		setLoading(true);
		const infodata = {
			...values,
			userId: parseInt(user_id.id),
			workPlaceId: parseInt(values.workPlaceId),
			startDate: dayjs(startDate).format("YYYY-MM-DD"),
			endDate: dayjs(endDate).format("YYYY-MM-DD"),
		};

		const resp = await addWorkPlaceHistory(infodata);

		if (resp.message === "success") {
			setLoader(false);
			dispatch(loadSingleStaff(user_id.id));
			setIsModalOpen(false);
			setLoading(false);
			form.resetFields();
		} else {
			setLoader(false);
			setLoading(false);
		}
	};

	const onFinishFailed = (errorInfo) => {
		toast.warning("Failed at adding department");
		setLoader(false);
		setLoading(false);
	};
	const showModal = () => {
		setIsModalOpen(true);
	};
	const handleOk = () => {
		setWorkPlaceStartDate(dayjs());
		setWorkPlaceEndDate(dayjs());
		setIsModalOpen(false);
		setLoader(false);
		setLoading(false);
		form.resetFields();
	};
	const handleCancel = () => {
		setWorkPlaceStartDate(dayjs());
		setWorkPlaceEndDate(dayjs());
		setIsModalOpen(false);
		setLoader(false);
		setLoading(false);
		form.resetFields();
	};

	useEffect(() => {
		// Fetching company names from getSetting API
		const fetchCompanyNames = async () => {
			setLoader(true);
			try {
				const response = await axios.get("setting/getCompanySetting");
				if (response?.data?.length) {
					const names = response.data.map((setting) => setting.company_name);
					// setCompanyNames(names);
					setCompanyNames(response.data.map(({ company_name, company_id }) => ({ company_name, company_id })));

				} else {
					console.error("Invalid data received from getSetting API:", response);
				}
			} catch (error) {
				console.error("Error fetching company names:", error);
			} finally {
				setLoader(false);
			}
		};

		fetchCompanyNames();
	}, []);

	useEffect(() => {
		// dispatch(getAllWorkPlace());
		dispatch(getCompanyOfficeMaster());
	}, []);

	return (
		<>
			<div className='text-center'>
				<Button type='primary' onClick={showModal}>
					Add New WorkPlace
				</Button>
			</div>
			<Modal
				title={`Add WorkPlace`}
				open={isModalOpen}
				onOk={handleOk}
				onCancel={handleCancel}>
				<Form
					form={form}
					style={{ marginBottom: "100px" }}
					eventKey='department-form'
					name='basic'
					labelCol={{
						span: 6,
					}}
					wrapperCol={{
						span: 16,
					}}
					onFinish={onFinish}
					onFinishFailed={onFinishFailed}
					autoComplete='off'>
					<div>
						{/* <Form.Item
							rules={[{ required: true, message: "Please select Work Place!" }]}
							label="Work Place"
							name="workPlaceId"
							style={{ marginBottom: "10px" }}
						>
							<Select
								loading={loader}
								placeholder="Please select Work Place"
								allowClear
								showSearch
								filterOption={(input, option) =>
									String(option.children).toLowerCase().includes(input.toLowerCase())
								}
							>
								{companyNames.map(({ company_name, company_id }) => (
									<Option key={company_id} value={company_id}>
										{company_name}
									</Option>
								))}
							</Select>
						</Form.Item> */}
						<Form.Item
							name={"workPlaceId"}
							style={{ marginBottom: "10px" }}
							rules={[
								{
									required: true,
									message: "Please Select work place!",
								},
							]}
							label='Work place'>
							<Select
								placeholder='Select work place'
								showSearch allowClear
								filterOption={(input, option) =>
									String(option.children).toLowerCase().includes(input.toLowerCase())
								}>
								{workPlace &&
									workPlace.map((workPlace) => (
										<Option
											key={workPlace.id}
											value={workPlace.id}>
											{workPlace.workplace}
										</Option>
									))}
							</Select>
						</Form.Item>

						<Form.Item
							style={{ marginBottom: "10px" }}
							label='Start Date'
							name='startDate'
							valuePropName='startDate'
							rules={[
								{
									required: true,
									message: "Please input your start date!",
								},
							]}>
							<DatePicker onChange={(date) => setWorkPlaceStartDate(date)} />
						</Form.Item>

						<Form.Item
							style={{ marginBottom: "10px" }}
							label='End Date'
							name='endDate'
							valuePropName='endDate'>
							<DatePicker onChange={(date) => setWorkPlaceEndDate(date)} />
						</Form.Item>

						<Form.Item
							style={{ marginBottom: "10px" }}
							label='Comment'
							name='comment'>
							<Input placeholder='Comment' />
						</Form.Item>

						<Form.Item
							style={{ marginBottom: "20px" }}
							wrapperCol={{
								offset: 6,
								span: 12,
							}}>
							<Button
								onClick={() => setLoader(true)}
								type='primary'
								size='small'
								htmlType='submit'
								block
								loading={loader}>
								Add Now
							</Button>
						</Form.Item>
					</div>
				</Form>
			</Modal>
		</>
	);
};
export default WorkPlaceAddSinglePopup;
